module.exports = __webpack_public_path__ + "images/webhooks/call_api_configuration.png";